import React, { forwardRef, useState, useEffect } from 'react';
import "./Table.css";
import { Typography ,Stack,Box,Grid} from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import PageLoader from "../commoncomponents/PageLoader";
const Ppmreport = forwardRef((props, ref) => {
    const { month, hospitalname, reportdata, className, year = new Date().getFullYear(), service, workgroup } = props;
    const [pageLoading, setPageLoading] = useState(false)
    const normalizedYear = typeof year === "object" && year.value ? year.value : year;
    const shortYear = normalizedYear.toString().slice(-2);
    const [weekDetails, setWeekDetails] = useState([]);
    const [isDataReady, setIsDataReady] = useState(false);
    const today = new Date();



    // Set the date to the 1st of the month
    const firstDate = `1/${today.getMonth() + 1}/${year}`; // Format: "1/MM/YYYY"
    const calculateWeeks = (year) => {
        setPageLoading(true);
        const firstDayOfYear = new Date(year, 0, 1);
        const lastDay = new Date(year, 11, 31);
        const weeks = [];
        const firstSunday = new Date(firstDayOfYear);
        firstSunday.setDate(firstSunday.getDate() - firstSunday.getDay());

        let current = new Date(firstSunday);

        while (current <= lastDay) {
            const weekStart = new Date(current);
            weeks.push({
                weekNumber: weeks.length + 1,
                startDate: `${weekStart.getDate().toString().padStart(2, "0")}-${weekStart.toLocaleString("en-US", { month: "short" })}`,
            });
            current.setDate(current.getDate() + 7);
        }
        setPageLoading(false);
        return weeks;

    };
    useEffect(() => {
        const weeks = calculateWeeks(normalizedYear);
        setWeekDetails(weeks);
        setIsDataReady(true);
    }, [normalizedYear]);

    const months = [
        { name: `Jan-${shortYear}`, weeks: 5 },
        { name: `Feb-${shortYear}`, weeks: 4 },
        { name: `Mar-${shortYear}`, weeks: 5 },
        { name: `Apr-${shortYear}`, weeks: 4 },
        { name: `May-${shortYear}`, weeks: 5 },
        { name: `Jun-${shortYear}`, weeks: 4 },
        { name: `Jul-${shortYear}`, weeks: 5 },
        { name: `Aug-${shortYear}`, weeks: 4 },
        { name: `Sep-${shortYear}`, weeks: 4 },
        { name: `Oct-${shortYear}`, weeks: 5 },
        { name: `Nov-${shortYear}`, weeks: 4 },
        { name: `Dec-${shortYear}`, weeks: 5 }
    ];
    const monthValue = (month.value === "All") ? "1" : month.value;
    const safeValue = (value) => value === "N/A" ? "" : value;
    console.log(service, "service")
    return (
        <>
            <PageLoader open={pageLoading} />
            <div id="capture" className={className} ref={ref} style={{ overflow: 'visible' }}>
                <div className="table-container" >

                    <table className="ppm-table">

                        <thead>
                            <tr>
                                <td colspan="62">
                                <Stack direction="row" alignItems="center" justifyContent="space-between" width="50%">
            {/* Logo */}
            <Box className="logo">
                <img
                    src={reportslogo}
                    alt="logo"
                    style={{
                        maxWidth: "150px",
                        height: "150px",
                        objectFit: "contain",
                    }}
                />
            </Box>

            {/* Header Content */}
            <Stack alignItems="center" textAlign="center" spacing={2}>
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: "40px",
                        fontFamily: "Arial Narrow",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        position: "relative",
                        left: "250px",
                        mb: 2,
                    }}
                >
                    PPM CALENDAR
                </Typography>

                {/* Details Section */}
                <Box width="100%" maxWidth="800px" mx="auto" pr={13}>
                    <Grid container spacing={2} px={5}>
                        {/* Left Side (Labels) */}
                        <Grid item xs={6}>
                            <Stack spacing={1} textAlign="left" sx={{ paddingLeft: '150px'}}>
                                <Typography variant="subtitle1" sx={{ fontSize: 15, fontWeight: "bold", whiteSpace: "nowrap" }}>
                                    Year : {year?.value}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: 15, fontWeight: "bold", whiteSpace: "nowrap" }}>
                                    {service?.value === "FEMS" ? "UNIT FACILITY" : "UNIT BIOMEDICAL"}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: 18, whiteSpace: "nowrap" }}>
                                    EQUIPMENT GROUP : {workgroup}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: 18, whiteSpace: "nowrap" }}>
                                    Hospital / Institutions: {hospitalname?.label}
                                </Typography>
                            </Stack>
                        </Grid>

                        {/* Right Side (Values) */}
                        <Grid item xs={6} >
                        <Stack spacing={1} textAlign="right" sx={{ paddingtop: '100px', paddingLeft:'500px'}}>

                                <Typography variant="subtitle1" sx={{ fontSize: 15, fontWeight: "bold", whiteSpace: "nowrap", paddingright:'200px'  }}>
                                    Prepared By : {reportdata?.ppmScheduleReportListVMs?.[0]?.approvedbyhss || ""}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: 15, fontWeight: "bold", whiteSpace: "nowrap", paddingright:'100px'  }}>
                                    Approved By : {reportdata?.ppmScheduleReportListVMs?.[0]?.approvedbymoh || ""}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: 15, whiteSpace: "nowrap" }}>
                                    Effective Date: 1/{monthValue}/{year?.value}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </Stack>
        </Stack>



                                </td>
                            </tr>
                            <tr>
                                <th colSpan="8" className="bond-header" style={{ fontWeight: "bold", textAlign: "center" }}>

                                </th>
                                {months.map((month, index) => (
                                    <th key={index} colSpan={month.weeks} style={{ textAlign: "center", padding: "2px" }}>
                                        {month.name}
                                    </th>
                                ))}
                            </tr>

                            <tr>
                                <td colSpan="8" className="bond-header" style={{ fontWeight: "bold", textAlign: "center" }}>Week No / Week Start Date</td>
                                {weekDetails.map(({ weekNumber }, index) => (
                                    <th key={index} style={{ padding: "2px" }}>{weekNumber}</th>
                                ))}
                            </tr>
                            <tr>
                                <td colSpan="8" className="bond-header" style={{ fontWeight: "bold", textAlign: "center" }}>Asset</td>
                                {weekDetails.map(({ startDate }, index) => (
                                    <td key={index} style={{ padding: "2px" }}>{startDate}</td>
                                ))}
                            </tr>
                            <tr>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>No</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Equipment Name</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Asset No</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Frequency</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Department</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Model</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle',wordWrap: "break-word" }}>Serial No</th>
                                <th rowSpan="3" style={{ textAlign: 'center', verticalAlign: 'middle' ,wordWrap: "break-word"}}>PPM Status</th>
                                {weekDetails.map((_, index) => (
                                    <th key={index}></th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {reportdata.ppmScheduleReportListVMs.length > 0 ? (
                                reportdata.ppmScheduleReportListVMs.map((item, index) => (
                                    <tr key={item.assetId || index}>
                                        <td>{index + 1}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.equipmentDescription)}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.assetName || "")}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>
                                            <span>{safeValue(item.intervalunit || "")}</span> <span>{safeValue(item.ppmintervaltype || "")}</span>
                                        </td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.department || "")}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.model || "")}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.serialNo || "")}</td>
                                        <td style={{ wordWrap: "break-word", whiteSpace: "normal", maxWidth: "150px", overflowWrap: "break-word" }}>{safeValue(item.ppmStatus || "")}</td>
                                        {weekDetails.map(({ weekNumber }) => {
                                            const matchingEntry = item.ppmTrackReportListVMs.find(vm =>
                                                (vm.week === weekNumber && vm.trackyear === item.schyear) || vm.week === weekNumber
                                            );

                                            const targetDate = matchingEntry?.targetdate ? new Date(matchingEntry.targetdate) : null;
                                            const isValidDate = targetDate && !isNaN(targetDate);
                                            const formattedDate = isValidDate
                                                ? targetDate.toLocaleDateString('en-US', { day: '2-digit' })
                                                : '';

                                            return (
                                                <td key={weekNumber}>
                                                    {matchingEntry ? (
                                                        <div>
                                                            <span>{formattedDate}</span>
                                                        </div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={61} style={{ border: "1px solid black", textAlign: "center" }}>
                                        No Record available
                                    </td>

                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </>
    );
});
export default Ppmreport;
